module.exports = __webpack_public_path__ + "static/media/impress.32ecf968.svg";